<template>
    <img class="ui avatar image" :src="avatarImg" :title="userName"
         style="margin: 0; background-color: #353535;">
</template>

<script>
    import Vue from 'vue'

    import userAvatar from '@/img/user.svg'

    export default {
        props: {
            img: {
                type: String,
                default: userAvatar
            },
            userName: {
                type: String,
                default: undefined
            }
        },
        data() {
            return {}
        },
        computed: {
            avatarImg() {
                return this.img || userAvatar
            },
        },
        methods: {}

    }
</script>

<style scoped>

</style>
